import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const FinalCTA = () => {
  return (
    <section className="relative py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-radial-glow pointer-events-none" />
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-tight">
          “Build The <span className="gradient-text">Backend</span> Your <span className="gradient-text">Business</span> Deserves.”
        </h2>
        <p className="mt-6 text-white/65 text-lg max-w-2xl mx-auto">
          Scale operations with AI-powered teams and operational infrastructure built for India’s most ambitious businesses.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link to="/services" className="btn-outline-cyan rounded-full px-7 py-3.5 text-sm font-semibold inline-flex items-center gap-2">
            Start Building <ArrowRight size={16} />
          </Link>
          <Link to="/contact" className="btn-outline-cyan rounded-full px-7 py-3.5 text-sm font-semibold inline-flex items-center gap-2">
            Schedule Consultation <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
